import "./es.symbol.description-6025a604.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.map-d821aaf5.js";
import "./es.function.name-b230e7d4.js";
import { T as Me, a as je, L as ge, C as ke, b as Re, M as Be } from "./tableSearchView-f1b86ba0.js";
import "./es.number.constructor-fc5c8929.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import { BREAKPOINTS as Ue } from "@ucl/shared-component-foundations/foundations";
import T, { useRef as Ae, useState as Ge, useContext as We, useMemo as ze, useEffect as ne } from "react";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import { g as He } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as qe } from "./useWindowSize.js";
import { Disclosures as Ke } from "./disclosure.js";
import { Spinner as Je } from "./spinner.js";
import { TableContext as De } from "./provider.js";
import { T as Qe } from "./tableContainer-531abf1b.js";
import "./es.array.find-index-cbf7640b.js";
import "./index-5d0f31c6.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.trim-6e13db75.js";
import Xe from "styled-components";
import { Button as Ye } from "./button.js";
import { StyledTableFilterGroup as Ze, Filter as er } from "./filter.js";
import { jsxs as X, jsx as b, Fragment as rr } from "react/jsx-runtime";
import { _ as tr } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { Pagination as lr } from "./pagination.js";
import { T as R } from "./tableV1-80a39fe6.js";
import { isCurrency as ce, parseCurrency as pe } from "./currency.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.array.splice-801adf1d.js";
import "./array-sort-7c90b530.js";
import "./uniqueId.js";
import "./index-f5b44da3.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./is-regexp-4c49b1c2.js";
import "./es.regexp.to-string-e800d529.js";
import "./set-species-5ede2ed0.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.parse-float-020a2ae0.js";
import "./string-trim-14e37ad3.js";
import "@ucl/ucl-translation";
import "./index-8b07dec9.js";
import "react-dom";
import "./aria.js";
import "./helperText.js";
import "./es.array.join-c1bca812.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./object-to-array-0474b7e7.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./isApiSupported-66660265.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./tableAccordionItem-b42a40b9.js";
import "@ucl/shared-icons";
import "./accordionPanel-89132988.js";
import "./debounce-350c74b3.js";
import "./is-pure-c0f11fe0.js";
import "./this-number-value-32e86ff7.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./es.array.reduce-2985ed2c.js";
import "./environment-is-node-a035d787.js";
import "./an-instance-6efcfd6c.js";
import "./chip.js";
import "./modalWindow.js";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./hooks_internal.js";
import "./analytics.js";
var nr = /* @__PURE__ */ Xe.span.withConfig({
  displayName: "tableFilterView__FilterGroupLabelSpan",
  componentId: "sc-15c1bls-0"
})(["display:flex;align-items:center;font-family:Inter;font-size:14px;font-weight:500;line-height:20px;text-align:left;"]), or = function(o) {
  var A = o.headerValues, V = o.rowValues, q = o.setRowValues, L = o.onClearAll, l = o.filterGroupLabel, K = l === void 0 ? "Filter by: " : l, W = o.clearAllLabel, Y = W === void 0 ? "Clear all" : W, O = o.setFilterEnabled, z = o.variant, I = z === void 0 ? "individual" : z, S = o.sortFilterValues, J = S === void 0 ? "desc" : S, Z = o.exceedOverflow, ee = Z === void 0 ? !1 : Z, N = Ae({}), te = Ge(!1), re = te[0], oe = te[1], u = Ae({}), de = We(De), ae = de.setAllCheckboxChecked, me = function(s, t) {
    if (!u.current[s] && I === "progressive") {
      var v;
      u.current = Object.assign({}, u.current, (v = {}, v[s] = {
        value: [t],
        selectedLevel: -1
      }, v));
    }
  }, ie = function(s, t) {
    var v = [], a = [], r = /* @__PURE__ */ new Set(), f = [];
    return A.forEach(function(d, c) {
      V.forEach(function(w) {
        var m, h, P = (m = (h = w.cellData[c]) == null ? void 0 : h.id) != null ? m : "", g = t.find(function(p) {
          return p.includes(P);
        });
        g && f.push(w.rowId);
      });
    }), A.forEach(function(d, c) {
      V.forEach(function(w) {
        var m, h, P, g = ((m = d.filterProp) == null ? void 0 : m.label) || d.textValue || "", p = ((h = w.cellData[c]) == null ? void 0 : h.textValue) || "", x = ((P = w.cellData[c]) == null ? void 0 : P.id) || "";
        if (f.includes(w.rowId) && g === s && !r.has(p))
          r.add(p), a.push({
            label: p,
            value: x
          });
        else if (f.includes(w.rowId) && g === s && r.has(p)) {
          var U = a.find(function(E) {
            return E.label === p;
          });
          U ? U.value += ", " + x : a.push({
            label: p,
            value: x
          });
        }
      });
    }), J === "asc" ? a.sort(function(d, c) {
      return d.label.localeCompare(c.label);
    }) : a.sort(function(d, c) {
      return c.label.localeCompare(d.label);
    }), v.push({
      items: a
    }), v;
  }, ue = function(s, t) {
    var v = 0;
    Object.keys(u.current).forEach(function(r) {
      v <= u.current[r].selectedLevel && (v = u.current[r].selectedLevel);
    });
    var a = v;
    Object.keys(u.current).forEach(function(r) {
      r === s && u.current[r].selectedLevel < 0 && (a = a + 1, u.current[r] = Object.assign({}, u.current[r], {
        selectedLevel: a
      }));
    }), Object.keys(u.current).forEach(function(r) {
      var f;
      if (r !== s && (u.current[r].selectedLevel >= a || u.current[r].selectedLevel < 0) && t.length) {
        var d = ie(r, t);
        u.current[r] = {
          value: d,
          selectedLevel: u.current[r].selectedLevel
        };
      } else if (!t.length && r === s)
        delete u.current[r];
      else if (!t.length && r !== s && (f = N.current[r]) != null && f.length) {
        var c, w = ie(r, N.current[r]);
        u.current[s] = {
          value: w,
          selectedLevel: ((c = u.current[s]) == null ? void 0 : c.selectedLevel) || -1
        };
        var m = A.findIndex(function(p) {
          return p.textValue === r;
        }), h = [], P = [], g = /* @__PURE__ */ new Set();
        V.forEach(function(p) {
          var x, U, E = ((x = p.cellData[m]) == null ? void 0 : x.textValue) || "", D = ((U = p.cellData[m]) == null ? void 0 : U.id) || "";
          if (E && !g.has(E))
            g.add(E), P.push({
              label: E,
              value: D
            });
          else if (E) {
            var G = P.find(function(Q) {
              return Q.label === E;
            });
            G ? G.value += ", " + D : P.push({
              label: E,
              value: D
            });
          }
        }), J === "asc" ? P.sort(function(p, x) {
          return p.label.localeCompare(x.label);
        }) : P.sort(function(p, x) {
          return x.label.localeCompare(p.label);
        }), h.push({
          items: P
        }), u.current[r] = {
          selectedLevel: u.current[r].selectedLevel,
          value: h
        };
      } else
        r !== s && (u.current[r].selectedLevel >= a || u.current[r].selectedLevel < 0) && !t.length && (u.current = {});
    });
  }, H = !!Object.keys(N.current).length, le = ze(function() {
    return !!H;
  }, [H]);
  ne(function() {
    O(le);
  }, [le]), ne(function() {
    oe(A.some(function($) {
      var s;
      return (s = $.filterProp) == null ? void 0 : s.isFilterEnabled;
    }));
  }, [A]);
  var B = function(s, t) {
    var v, a, r, f, d, c, w = [], m = [], h = /* @__PURE__ */ new Set();
    V.forEach(function(p) {
      var x, U, E = ((x = p.cellData[s]) == null ? void 0 : x.textValue) || "", D = ((U = p.cellData[s]) == null ? void 0 : U.id) || "";
      if (E && !h.has(E))
        h.add(E), m.push({
          label: E,
          value: D
        });
      else if (E) {
        var G = m.find(function(Q) {
          return Q.label === E;
        });
        G ? G.value += ", " + D : m.push({
          label: E,
          value: D
        });
      }
    }), J === "asc" ? m.sort(function(p, x) {
      return p.label.localeCompare(x.label);
    }) : m.sort(function(p, x) {
      return x.label.localeCompare(p.label);
    }), w.push({
      items: m
    }), me(((v = t.filterProp) == null ? void 0 : v.label) || t.textValue || "", {
      items: m
    });
    var P = N.current[((a = t.filterProp) == null ? void 0 : a.label) || t.textValue || ""] || [], g = ((r = t.filterProp) == null ? void 0 : r.menuOptions) || u.current[((f = t.filterProp) == null ? void 0 : f.label) || t.textValue || ""] && u.current[((d = t.filterProp) == null ? void 0 : d.label) || t.textValue || ""].value.length && [].concat(u.current[((c = t.filterProp) == null ? void 0 : c.label) || t.textValue || ""].value) || w;
    return {
      newFilterMenuList: g,
      values: P
    };
  }, ve = function() {
    var s = [];
    return A.forEach(function(t, v) {
      var a;
      if ((a = t.filterProp) != null && a.isFilterEnabled) {
        var r, f, d = B(v, t), c = d.newFilterMenuList, w = d.values;
        s.push(/* @__PURE__ */ b(er, {
          exceedOverflow: ee,
          menuDirection: (r = t.filterProp) == null ? void 0 : r.menuDirection,
          menuHeader: "local_search",
          menuLists: c,
          onChange: function(h, P) {
            var g;
            if (h.preventDefault(), h.stopPropagation(), be(h, P), (g = t.filterProp) != null && g.onClick) {
              var p;
              (p = t.filterProp) == null || p.onClick(h, P);
            }
          },
          value: w,
          children: ((f = t.filterProp) == null ? void 0 : f.label) || t.textValue || ""
        }, t.id));
      }
    }), s;
  }, se = function(s, t, v) {
    s.cellData.find(function(a) {
      return a.id === t;
    }) && !v.includes(s) && v.push(s);
  }, fe = function() {
    var s = [];
    return V.forEach(function(t) {
      var v = !0;
      Object.entries(N.current).forEach(function(a) {
        var r = a[0], f = a[1];
        if (f.length > 0) {
          var d, c = [];
          f.forEach(function(g) {
            g.includes(",") ? g.split(",").forEach(function(p) {
              c.push(p.trim());
            }) : c.push(g);
          });
          var w = A.findIndex(function(g) {
            var p;
            return ((p = g.filterProp) == null ? void 0 : p.label) === r || g.textValue === r;
          }), m = ((d = t.cellData[w]) == null ? void 0 : d.id) || "", h = c.includes(m);
          if (h) {
            if (u.current[r].selectedLevel === -1)
              v = !1;
            else if (u.current[r].selectedLevel > -1 && u.current[r]) {
              var P = u.current[r].selectedLevel;
              P !== u.current[r].selectedLevel && (v = !1);
            }
          }
          !h && u.current[r].selectedLevel > -1 && (v = !1);
        }
      }), v && s.push(t);
    }), s;
  }, be = function(s, t) {
    var v;
    s.preventDefault();
    var a = t.label, r = [];
    t.values.forEach(function(c) {
      r.push(c);
    });
    var f = Object.assign({}, N.current, (v = {}, v[a] = r, v));
    Object.keys(f).every(function(c) {
      return f[c].length === 0;
    }) ? N.current = {} : N.current = f;
    var d = [];
    I === "progressive" ? (ue(a, t.values), d = fe()) : Object.keys(f).forEach(function(c) {
      var w = [].concat(f[c]);
      V.forEach(function(m) {
        w.forEach(function(h) {
          h.includes(",") ? h.split(",").forEach(function(P) {
            return se(m, P.trim(), d);
          }) : se(m, h, d);
        });
      });
    }), d.length ? q(d) : (ae(0), q(V));
  }, he = function(s) {
    s.preventDefault(), L && L(s), q(V), u.current = {}, N.current = {}, ae(0);
  };
  return re && /* @__PURE__ */ X(Ze, {
    children: [/* @__PURE__ */ b(nr, {
      children: K
    }), ve(), /* @__PURE__ */ b(Ye, {
      fullWidthMobile: !1,
      size: "small",
      variant: "tertiary",
      onClick: he,
      children: Y
    })]
  }) || /* @__PURE__ */ b(rr, {});
}, ar = ["totalItems", "tablePage", "initialItemsPerPage", "itemsPerPage", "setTablePage", "showTotalItems", "showPerPageOption", "perPageLabel", "itemsLabel", "placeholder", "onItemsPerPageChange"], ir = function(o) {
  var A = o.totalItems, V = o.tablePage, q = o.initialItemsPerPage, L = o.itemsPerPage, l = o.setTablePage, K = o.showTotalItems, W = K === void 0 ? !0 : K, Y = o.showPerPageOption, O = Y === void 0 ? !0 : Y, z = o.perPageLabel, I = z === void 0 ? "per page" : z, S = o.itemsLabel, J = S === void 0 ? "of items" : S, Z = o.placeholder, ee = o.onItemsPerPageChange, N = tr(o, ar);
  return /* @__PURE__ */ b(lr, Object.assign({
    totalItems: A,
    page: V,
    initialItemsPerPage: q,
    itemsPerPage: L,
    onItemsPerPageChange: ee,
    showTotalItems: W,
    showPerPageOption: O,
    onPageChange: l,
    perPageLabel: I,
    itemsLabel: J,
    placeholder: Z
  }, N));
}, Bl = function(o) {
  var A = o.headerValues, V = A === void 0 ? [] : A, q = o.rowValues, L = q === void 0 ? [] : q, l = o.paginationProp, K = o.isStickyColumnEnabled, W = o.isOptionProps, Y = o.isCheckboxEnabled, O = o.disclosures, z = o.searchProp, I = o.filterProps, S = o.headerCheckboxProps, J = o.emptyTableMessage, Z = J === void 0 ? "There is no data to display" : J, ee = o.isStatic, N = ee === void 0 ? !1 : ee, te = o.sortingProps, re = te === void 0 ? {
    columnNumber: 0,
    order: "default"
  } : te, oe = o.showLoader, u = oe === void 0 ? !1 : oe, de = o["aria-label"], ae = He({
    label: "DataTable"
  }), me = qe(), ie = me.width, ue = T.useState(1), H = ue[0], le = ue[1], B = T.useContext(De), ve = B.setShowOptionsEnabled, se = B.setShowCheckboxEnabled, fe = B.setIsStickyColumnEnabled, be = B.assignCheckboxesDefaultValues, he = B.setAllCheckboxChecked, $ = B.sortOrder, s = B.setSortOrder, t = B.setRowIds, v = T.useState([]), a = v[0], r = v[1], f = T.useRef([]), d = T.useRef(0), c = T.useRef(!1), w = T.useState(!1), m = w[0], h = w[1], P = T.useState(!1), g = P[0], p = P[1], x = T.useState(5), U = x[0], E = x[1];
  ne(function() {
    d.current = (l == null ? void 0 : l.itemsPerPage) || 0;
  }, [l == null ? void 0 : l.itemsPerPage]);
  var D = function(e) {
    return e == null ? void 0 : e.map(function(i) {
      return i == null ? void 0 : i.rowId;
    });
  };
  ne(function() {
    var n = {
      columnNumber: re.columnNumber || $.columnNumber,
      value: re.order || $.value
    };
    s(n);
  }, [re.columnNumber, re.order]), ne(function() {
    if (m || c.current) {
      var n = D(a);
      t && t(n);
    } else {
      var e = D(L);
      t && t(e);
    }
  }, [L, a, m, c.current]);
  var G = function(e) {
    var i = e.newTablePage, C = e.newUpdatedRowValues, _ = e.sortOrderValue, y = e.comparator;
    if (N) {
      f.current = C;
      var Ce = C;
      r(Ce.length === 0 ? [] : Ce);
    } else {
      var M = [], F = _ ?? $;
      if (g && (F == null ? void 0 : F.value) !== "default" && (M = C.slice().sort(function($e, xe) {
        var Ee, Le, Te, Se, Oe, Ie, Fe, Ne, j = (Ee = (Le = (Te = $e.cellData[F.columnNumber]) == null ? void 0 : Te.textValue) != null ? Le : (Se = $e.cellData[F.columnNumber]) == null ? void 0 : Se.cellAltText) != null ? Ee : "", k = (Oe = (Ie = (Fe = xe.cellData[F.columnNumber]) == null ? void 0 : Fe.textValue) != null ? Ie : (Ne = xe.cellData[F.columnNumber]) == null ? void 0 : Ne.cellAltText) != null ? Oe : "";
        return y ? y(j, k, F.value === "desc") : F.value === "asc" ? !isNaN(Number(j)) && !isNaN(Number(k)) ? Number(j) - Number(k) : ce(j) && ce(k) ? pe(j) - pe(k) : j.localeCompare(k) : !isNaN(Number(j)) && !isNaN(Number(k)) ? Number(k) - Number(j) : ce(j) && ce(k) ? pe(k) - pe(j) : k.localeCompare(j);
      })), l && l != null && l.isPaginationEnabled && g && (F == null ? void 0 : F.value) !== "default") {
        f.current = M;
        var Ve = M.slice((i - 1) * d.current, i * d.current);
        r(Ve.length === 0 ? [] : Ve);
      } else if (g && (F == null ? void 0 : F.value) !== "default")
        r(M);
      else if (l && l.isPaginationEnabled) {
        f.current = C;
        var we = C.slice((i - 1) * d.current, i * d.current);
        r(we.length === 0 ? [] : we);
      } else
        r(C);
      i !== H && _e(i);
    }
  };
  T.useEffect(function() {
    var n, e = L;
    (m || c.current) && (e = L.filter(function(i) {
      return !!a.find(function(C) {
        return C.rowId === i.rowId;
      });
    })), G({
      newUpdatedRowValues: e,
      newTablePage: (m || c.current) && H || H,
      sortOrderValue: $,
      comparator: (n = V[$.columnNumber]) == null || (n = n.sortingProp) == null ? void 0 : n.comparator
    });
  }, [V, L, d, g]);
  var Q = function(e) {
    var i = e.rowValues, C = e.sortOrderValue, _ = e.filterOrSearchEnabled, y = e.comparator;
    G({
      newUpdatedRowValues: i,
      newTablePage: _ && 1 || H,
      sortOrderValue: C,
      comparator: y
    });
  };
  T.useEffect(function() {
    l != null && l.tablePage && l.tablePage !== H && le(l == null ? void 0 : l.tablePage);
  }, [l == null ? void 0 : l.tablePage]), T.useEffect(function() {
    ve(!!(W != null && W.isOptionsEnabled));
  }, [W == null ? void 0 : W.isOptionsEnabled]), T.useEffect(function() {
    fe(!!K);
  }, [K]), T.useEffect(function() {
    if (L.length) {
      var n = [];
      L.forEach(function(e) {
        var i, C, _, y, M = (i = (C = S == null ? void 0 : S.checkboxDefaultValue) != null ? C : (_ = e.checkboxProps) == null ? void 0 : _.checkboxDefaultValue) != null ? i : 0;
        n.push({
          id: e.rowId,
          value: M,
          disabled: ((y = e.checkboxProps) == null ? void 0 : y.disabled) || !1
        });
      }), be(n), S != null && S.checkboxDefaultValue && he(S == null ? void 0 : S.checkboxDefaultValue, n);
    }
  }, [L, S == null ? void 0 : S.checkboxDefaultValue]), T.useEffect(function() {
    se(!!Y);
  }, [Y]);
  var ye = T.useCallback(function() {
    E((l == null ? void 0 : l.totalItems) || f.current.length);
  }, [l == null ? void 0 : l.totalItems, f.current.length]);
  T.useEffect(function() {
    ye();
  }, [l == null ? void 0 : l.totalItems, f.current.length]);
  var _e = function(e) {
    l != null && l.setTablePage && (l == null || l.setTablePage(e)), le(e);
  };
  return /* @__PURE__ */ X(Qe, Object.assign({}, ae, {
    children: [(z == null ? void 0 : z.isSearchEnabled) && /* @__PURE__ */ b(Me, Object.assign({
      rowValues: m && a || L,
      setRowValues: function(e) {
        Q({
          rowValues: e,
          filterOrSearchEnabled: !0
        });
      },
      setSearchEnabled: function(e) {
        return c.current = e;
      },
      isStatic: N
    }, z)), (I == null ? void 0 : I.isFilterEnabled) && /* @__PURE__ */ b(or, {
      variant: I.variant,
      sortFilterValues: I.sortFilterValues,
      headerValues: V,
      rowValues: c.current && a || L,
      setRowValues: function(e) {
        Q({
          rowValues: e,
          filterOrSearchEnabled: !0
        });
      },
      onClearAll: I == null ? void 0 : I.onClearAll,
      filterGroupLabel: I == null ? void 0 : I.filterGroupLabel,
      setFilterEnabled: h,
      clearAllLabel: I == null ? void 0 : I.clearAllLabel,
      exceedOverflow: K
    }), ie >= Ue.tabletMin ? /* @__PURE__ */ X(R, {
      isEmpty: !a.length,
      "aria-label": de,
      children: [/* @__PURE__ */ b(R.Head, {
        $checkboxProps: S,
        rowIds: m || c.current ? D(a) : D(L),
        children: V.map(function(n, e) {
          var i, C;
          return /* @__PURE__ */ b(R.Header, {
            children: /* @__PURE__ */ X(R.CellContent, {
              $contentAlignment: (n == null ? void 0 : n.contentAlignment) || "center",
              children: [n.leadingComponents, n.textValue && /* @__PURE__ */ b(R.CellContentText, {
                contentAlignment: (n == null ? void 0 : n.contentAlignment) || "center",
                children: n.textValue
              }), n.trailingComponents, ((i = n.sortingProp) == null ? void 0 : i.isSortingEnabled) && /* @__PURE__ */ b(je, {
                rowValues: (c.current || m) && a || L,
                setRowValues: function(y, M) {
                  var F;
                  Q({
                    rowValues: y,
                    sortOrderValue: M,
                    comparator: (F = n.sortingProp) == null ? void 0 : F.comparator
                  });
                },
                columnName: n.textValue || n.columnAlternateText || "",
                columnNumber: e,
                onClick: (C = n.sortingProp) == null ? void 0 : C.onClick,
                setSortingEnabled: p
              })]
            })
          }, "" + n.id);
        })
      }), /* @__PURE__ */ X(R.Body, {
        children: [!u && a.map(function(n) {
          return /* @__PURE__ */ b(R.Row, {
            id: n.rowId,
            $checkboxProps: n.checkboxProps,
            $dropDownComponent: n.DropDownComponent,
            children: n.cellData.map(function(e, i) {
              var C, _, y, M;
              return /* @__PURE__ */ b(R.Cell, {
                $contentAlignment: ((C = V[i]) == null ? void 0 : C.contentAlignment) || "center",
                id: e.id,
                children: /* @__PURE__ */ X(R.CellWrapper, {
                  $contentAlignment: ((_ = V[i]) == null ? void 0 : _.contentAlignment) || "center",
                  children: [e.leadingComponents && /* @__PURE__ */ b(ge, {
                    children: e.leadingComponents
                  }), (e.textValue || e.trailingComponents || e.description || (e == null ? void 0 : e.secondaryDescription)) && /* @__PURE__ */ X(ke, {
                    children: [/* @__PURE__ */ X(R.CellContent, {
                      $contentAlignment: ((y = V[i]) == null ? void 0 : y.contentAlignment) || "center",
                      children: [e.textValue && /* @__PURE__ */ b(R.CellContentText, {
                        contentAlignment: ((M = V[i]) == null ? void 0 : M.contentAlignment) || "center",
                        children: e.textValue
                      }), e.trailingComponents && !e.textValue && /* @__PURE__ */ b(ge, {
                        children: e.trailingComponents
                      })]
                    }), e.description && /* @__PURE__ */ b(R.CellDescription, {
                      children: e.description
                    }), (e == null ? void 0 : e.secondaryDescription) && /* @__PURE__ */ b(R.CellDescription, {
                      children: e == null ? void 0 : e.secondaryDescription
                    })]
                  }), e.trailingComponents && e.textValue && /* @__PURE__ */ b(ge, {
                    children: e.trailingComponents
                  })]
                })
              }, "" + (e.id || i));
            })
          }, "" + n.rowId);
        }), a.length === 0 && /* @__PURE__ */ b(Re, {
          isMobile: !1,
          children: Z
        }) || u && /* @__PURE__ */ b(Re, {
          isMobile: !1,
          children: /* @__PURE__ */ b(Je, {
            size: "medium"
          })
        })]
      })]
    }) : /* @__PURE__ */ b(R.Container, {
      children: /* @__PURE__ */ b(Be, {
        setSortingEnabled: p,
        emptyTableMessage: Z,
        headerValues: V,
        rowValues: a,
        setRowValues: function(e, i, C) {
          Q({
            rowValues: e,
            sortOrderValue: i,
            comparator: C
          });
        },
        headerCheckboxProps: S
      })
    }), O && /* @__PURE__ */ b(Ke, {
      disclosureContent: O == null ? void 0 : O.disclosureContent,
      id: O == null ? void 0 : O.id,
      className: O == null ? void 0 : O.className,
      disclosureTitleColor: O == null ? void 0 : O.disclosureTitleColor,
      style: O == null ? void 0 : O.style
    }), (l == null ? void 0 : l.isPaginationEnabled) && /* @__PURE__ */ b(ir, Object.assign({}, l, {
      totalItems: U,
      tablePage: H,
      itemsPerPage: d.current,
      onItemsPerPageChange: function(e) {
        var i;
        l != null && l.onItemsPerPageChange && (l == null || l.onItemsPerPageChange == null || l.onItemsPerPageChange(e)), d.current = e, G({
          newUpdatedRowValues: f.current,
          newTablePage: 1,
          sortOrderValue: $,
          comparator: (i = V[$.columnNumber]) == null || (i = i.sortingProp) == null ? void 0 : i.comparator
        });
      },
      setTablePage: function(e) {
        var i;
        G({
          newUpdatedRowValues: (c.current || m) && f.current || L,
          newTablePage: e,
          sortOrderValue: $,
          comparator: (i = V[$.columnNumber]) == null || (i = i.sortingProp) == null ? void 0 : i.comparator
        }), l && l != null && l.setTablePage && l.setTablePage(e);
      }
    }))]
  }));
};
export {
  Bl as DataTable
};
